"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Cross = _interopRequireDefault(require("../Icons/all/Cross"));

var _Search = _interopRequireDefault(require("../Icons/all/Search"));

var _commonHelper = require("../helpers/commonHelper");

var _debounce2 = _interopRequireDefault(require("lodash-es/debounce"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _OnClickOutside = _interopRequireDefault(require("../HOC/OnClickOutside"));

var _DownTriangle = _interopRequireDefault(require("../Icons/all/DownTriangle"));

var _Textfield = _interopRequireDefault(require("./Textfield"));

var _misc = _interopRequireDefault(require("../tokens/misc"));

var _color = require("../tokens/color");

var _uniqueIdHelper = _interopRequireDefault(require("../helpers/uniqueIdHelper"));

var Searchbox = function Searchbox(_ref) {
  var width = _ref.width,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$forceRenderValue = _ref.forceRenderValue,
      forceRenderValue = _ref$forceRenderValue === void 0 ? false : _ref$forceRenderValue,
      rightIcon = _ref.rightIcon,
      leftIcon = _ref.leftIcon,
      children = _ref.children,
      onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "" : _ref$type,
      _ref$tagType = _ref.tagType,
      tagType = _ref$tagType === void 0 ? "default" : _ref$tagType,
      _ref$showLeftIcon = _ref.showLeftIcon,
      showLeftIcon = _ref$showLeftIcon === void 0 ? true : _ref$showLeftIcon,
      _ref$showDropdownArro = _ref.showDropdownArrow,
      showDropdownArrow = _ref$showDropdownArro === void 0 ? true : _ref$showDropdownArro,
      _ref$onCloseIconClick = _ref.onCloseIconClick,
      onCloseIconClick = _ref$onCloseIconClick === void 0 ? _noop2["default"] : _ref$onCloseIconClick,
      _ref$isNaked = _ref.isNaked,
      isNaked = _ref$isNaked === void 0 ? false : _ref$isNaked,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$maxMenuHeight = _ref.maxMenuHeight,
      maxMenuHeight = _ref$maxMenuHeight === void 0 ? "30rem" : _ref$maxMenuHeight,
      _ref$inputWidth = _ref.inputWidth,
      inputWidth = _ref$inputWidth === void 0 ? "" : _ref$inputWidth,
      _ref$NoResultComponen = _ref.NoResultComponent,
      NoResultComponent = _ref$NoResultComponen === void 0 ? null : _ref$NoResultComponen,
      _ref$errorText = _ref.errorText,
      errorText = _ref$errorText === void 0 ? "" : _ref$errorText,
      placeholderFont = _ref.placeholderFont,
      _ref$headerFont = _ref.headerFont,
      headerFont = _ref$headerFont === void 0 ? "18px" : _ref$headerFont,
      selectedTags = _ref.selectedTags,
      isMenuVisible = _ref.isMenuVisible,
      onFocus = _ref.onFocus,
      maxLength = _ref.maxLength;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      searchString = _useState2[0],
      setEscapedSearchString = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      showMenu = _useState6[0],
      setMenuVisibility = _useState6[1];

  var _useState7 = (0, _react.useState)(selectedTags),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      tag = _useState8[0],
      setTag = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      tagValues = _useState10[0],
      setTagValues = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      childInputRef = _useState12[0],
      setChildInputRef = _useState12[1];

  var _useState13 = (0, _react.useState)(!!_react["default"].Children.count(children)),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      hasResult = _useState14[0],
      setHasResult = _useState14[1];

  var _useState15 = (0, _react.useState)(0),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      selectedChild = _useState16[0],
      setSelectedChild = _useState16[1];

  var hasInput = !!searchString.length;
  var isTag = type === "tag";
  var node = (0, _react.useRef)();
  var parent = (0, _react.useRef)();
  var resultWrapperRef = (0, _react.useRef)();
  var searchBoxLabelId = "searchbox-label_".concat((0, _uniqueIdHelper["default"])());
  (0, _react.useEffect)(function () {
    setTag(selectedTags);
  }, [selectedTags]);
  (0, _react.useEffect)(function () {
    setSearchString(value);
  }, [value]);

  var setSearchString = function setSearchString(str) {
    setEscapedSearchString(str.replace(/[.*+?^${}()|[\]\\\/]/g, ""));
  };

  var onInputChange = function onInputChange(e) {
    e.persist();
    var value = e.target.value || "";
    setSearchString(e.target.value);
    setLoading(true);
    setMenuVisibility(true);
    parent.current.debouncedOnChange(value, e);
  };

  var handleRightIconClick = function handleRightIconClick(e) {
    e.stopPropagation();
    node.current.focus();
    setSearchString("");
    onCloseIconClick();
  };

  var handleOnSelect = function handleOnSelect(value, label) {
    if (isTag) {
      setSearchString("");
      var newTags = [].concat((0, _toConsumableArray2["default"])(tag), [{
        label: label,
        value: value
      }]);
      var newTagValues = newTags.map(function (tag) {
        return tag.value;
      });
      setTagValues(newTagValues);
      setTag(newTags);
      onSelect(newTagValues);
    } else {
      setSearchString(label);
      onSelect(value);
      closeMenu();
    }
  };

  var onRemoveItem = function onRemoveItem(item) {
    var filtered = tag.filter(function (t) {
      return t.value !== item;
    });
    var newTags = filtered.map(function (tag) {
      return tag.value;
    });
    setTagValues(newTags);
    setTag(filtered);
    onSelect(newTags);
    children && _react["default"].Children.count(children) && setHasResult(true);
  };

  var suppressClick = function suppressClick(e) {
    if (showMenu) e.stopPropagation();
  };

  var handleFocus = function handleFocus() {
    isTag ? childInputRef.current.focus() : node.current.focus();
  };

  (0, _react.useEffect)(function () {
    children && _react["default"].Children.count(children) ? setHasResult(true) : setHasResult(false);
    setLoading(false);
    setSelectedChild(0);
  }, [children]);
  (0, _react.useEffect)(function () {
    if (forceRenderValue) {
      setSearchString(value);
    }
  }, [forceRenderValue]);
  (0, _react.useEffect)(function () {
    parent.current.debouncedOnChange = (0, _debounce2["default"])(onChange, 400);
  }, [children, onChange]);

  var openMenu = function openMenu() {
    onFocus();
    setMenuVisibility(true);
  };

  var closeMenu = function closeMenu() {
    setMenuVisibility(false);
    setSelectedChild(0);
  };

  var handleMenuScrolling = function handleMenuScrolling(direction) {
    if (resultWrapperRef.current && children.length) {
      var _resultWrapperRef$cur = resultWrapperRef.current,
          _resultWrapperRef$cur2 = _resultWrapperRef$cur.scrollHeight,
          scrollHeight = _resultWrapperRef$cur2 === void 0 ? 0 : _resultWrapperRef$cur2,
          _resultWrapperRef$cur3 = _resultWrapperRef$cur.scrollTop,
          scrollTop = _resultWrapperRef$cur3 === void 0 ? 0 : _resultWrapperRef$cur3,
          _resultWrapperRef$cur4 = _resultWrapperRef$cur.clientHeight,
          clientHeight = _resultWrapperRef$cur4 === void 0 ? 0 : _resultWrapperRef$cur4;
      var itemHeight = scrollHeight / children.length;
      var currentPosition = (selectedChild + 1) * itemHeight;

      if (direction === "up") {
        if (currentPosition > clientHeight) resultWrapperRef.current.scrollTop = scrollTop - itemHeight;
      } else {
        if (currentPosition > clientHeight) resultWrapperRef.current.scrollTop = scrollTop + itemHeight;
      }
    }
  };

  var handleItemSelect = function handleItemSelect(e, key) {
    if (showMenu && hasResult) {
      var handleUpKeyPress = function handleUpKeyPress() {
        if (!selectedChild) {
          setSelectedChild(1);
        } else {
          if (selectedChild !== 1) setSelectedChild(selectedChild - 1);
        }

        handleMenuScrolling("up");
      };

      var handleDownKeyPress = function handleDownKeyPress() {
        if (!selectedChild) setSelectedChild(1);
        if (selectedChild !== modifiedChildrenCount) setSelectedChild(selectedChild + 1);
        handleMenuScrolling("down");
      };

      var handleEnterKeyPress = function handleEnterKeyPress() {
        if (selectedChild) {
          var selected = childValueLabelMapping[selectedChild] || {};

          var _selected$value = selected.value,
              _value = _selected$value === void 0 ? "" : _selected$value,
              _selected$label = selected.label,
              label = _selected$label === void 0 ? "" : _selected$label;

          setSelectedChild(0);
          handleOnSelect(_value, label);
        }
      };

      switch (key) {
        case "UP":
          handleUpKeyPress();
          break;

        case "DOWN":
          handleDownKeyPress();
          break;

        case "ENTER":
          handleEnterKeyPress();
          break;
      }
    }
  };

  var randomId = "id-" + (Math.random() * 10).toFixed(3);
  var childValueLabelMapping = {};
  var modifiedChildrenCount = 0;

  var renderModifiedChildren = function renderModifiedChildren() {
    var allChildren = [];
    var count = 0;

    _react["default"].Children.forEach(children, function (ch) {
      if (!tagValues.includes(ch.props.value)) {
        count++;
        var keySelected = selectedChild === count;
        childValueLabelMapping[count] = {
          value: ch.props.value,
          label: ch.props.label
        };
        allChildren.push((0, _commonHelper.cloneChildren)(ch, {
          _passClick: handleOnSelect,
          bold: searchString,
          id: randomId,
          keySelected: keySelected
        }));
      }
    });

    modifiedChildrenCount = allChildren.length;

    if (!modifiedChildrenCount) {
      setHasResult(false);
    }

    return allChildren;
  };

  return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
    handleClickOutside: closeMenu,
    width: width
  }, /*#__PURE__*/_react["default"].createElement(Searchbox.Wrapper, {
    className: className,
    ref: parent,
    isTag: isTag,
    "aria-labelledby": searchBoxLabelId,
    width: width,
    isNaked: isNaked
  }, /*#__PURE__*/_react["default"].createElement(Searchbox.label, {
    id: searchBoxLabelId,
    className: "label"
  }, placeholder), /*#__PURE__*/_react["default"].createElement(Searchbox.HeadHolder, {
    isTag: isTag
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "inherit"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "inherit"
    }
  }, /*#__PURE__*/_react["default"].createElement(Searchbox.Header, {
    showMenu: showMenu,
    noPadding: isTag && tag.length,
    onClick: handleFocus,
    width: width,
    onFocus: openMenu,
    onKeyDown: (0, _commonHelper.onKeyChoose)(handleItemSelect),
    isNaked: isNaked,
    isError: !!errorText,
    headerFont: headerFont
  }, /*#__PURE__*/_react["default"].createElement(Searchbox.Left, {
    isTag: isTag
  }, !isTag && showLeftIcon && (0, _commonHelper.cloneChildren)(leftIcon, {
    size: 16,
    color: _color.grey.z400
  }), isTag ? /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    placeholder: placeholder,
    placeholderFont: placeholderFont,
    searchStr: searchString,
    onChange: onInputChange,
    onRemove: onRemoveItem,
    isMenuOpen: showMenu,
    value: searchString,
    tags: tag,
    type: tagType,
    setInputRef: setChildInputRef,
    maxLength: maxLength
  }) : /*#__PURE__*/_react["default"].createElement(Searchbox.Input, {
    width: inputWidth,
    placeholder: placeholder,
    onChange: onInputChange,
    value: searchString,
    ref: node,
    onClick: suppressClick,
    disabled: disabled,
    hasInput: hasInput,
    placeholderFont: placeholderFont,
    headerFont: headerFont,
    maxLength: maxLength
  })), !isTag && showDropdownArrow && /*#__PURE__*/_react["default"].createElement(RightIcon, null, hasInput ? /*#__PURE__*/_react["default"].createElement(_Cross["default"], {
    onClick: handleRightIconClick,
    onKeyUp: (0, _commonHelper.onKeySelect)(handleRightIconClick),
    size: 14,
    color: _color.grey.z400,
    showPointer: hasInput,
    "aria-label": hasInput ? "clear input" : "",
    tabIndex: "0"
  }) : rightIcon ? (0, _commonHelper.cloneChildren)(rightIcon, {
    size: 14,
    color: _color.grey.z400
  }) : null))), isMenuVisible && /*#__PURE__*/_react["default"].createElement(Searchbox.Holder, null, /*#__PURE__*/_react["default"].createElement(Searchbox.ListWrapper, {
    isOpen: showMenu,
    onClick: closeMenu
  }, showMenu && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Searchbox.Cover, null), /*#__PURE__*/_react["default"].createElement(HR, null), loading ? /*#__PURE__*/_react["default"].createElement(SpinnerHolder, null, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    color: _color.red.z500
  })) : hasResult ? /*#__PURE__*/_react["default"].createElement(ResultWrapper, {
    maxMenuHeight: maxMenuHeight,
    ref: resultWrapperRef
  }, renderModifiedChildren(children)) : /*#__PURE__*/_react["default"].createElement(NoResultFound, {
    NoResultComponent: NoResultComponent
  })))))), /*#__PURE__*/_react["default"].createElement(Errortext, {
    isError: !!errorText
  }, errorText)));
};

var Errortext = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  componentId: "sc-1fxn1mt-0"
})(["margin:0.2rem 0 0 0;color:#d64155;font-size:1.1rem;opacity:", ";"], function (props) {
  return props.isError ? 1 : 0;
});

var ResultWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-1"
})(["height:100%;width:100%;max-height:", ";overflow-y:auto;"], function (props) {
  return props.maxMenuHeight;
});

var NoResultFound = function NoResultFound(_ref2) {
  var _ref2$NoResultCompone = _ref2.NoResultComponent,
      NoResultComponent = _ref2$NoResultCompone === void 0 ? null : _ref2$NoResultCompone;
  return NoResultComponent ? NoResultComponent : /*#__PURE__*/_react["default"].createElement("p", null, "No result found!");
};

NoResultFound.propTypes = {
  NoResultComponent: _propTypes["default"].node
};
Searchbox.HeadHolder = _styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-2"
})(["", ""], function (props) {
  return !props.isTag && (0, _styledComponents.css)(["width:100%;display:flex;"]);
});
Searchbox.propTypes = {
  width: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  rightIcon: _propTypes["default"].node,
  leftIcon: _propTypes["default"].node,
  children: _propTypes["default"].node,
  onChange: _propTypes["default"].func.isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  tagType: _propTypes["default"].oneOf(["red", "green", "default"]),
  showLeftIcon: _propTypes["default"].bool,
  showDropdownArrow: _propTypes["default"].bool,
  onCloseIconClick: _propTypes["default"].func,
  isNaked: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  maxMenuHeight: _propTypes["default"].string,
  forceRenderValue: _propTypes["default"].bool,
  inputWidth: _propTypes["default"].string,
  NoResultComponent: _propTypes["default"].node,
  errorText: _propTypes["default"].string,
  placeholderFont: _propTypes["default"].string,
  headerFont: _propTypes["default"].string,
  selectedTags: _propTypes["default"].array,
  isMenuVisible: _propTypes["default"].bool,
  onFocus: _propTypes["default"].func,
  maxLength: _propTypes["default"].string
};
Searchbox.defaultProps = {
  placeholder: "Start typing to search...",
  rightIcon: /*#__PURE__*/_react["default"].createElement(_DownTriangle["default"], null),
  leftIcon: /*#__PURE__*/_react["default"].createElement(_Search["default"], null),
  disabled: false,
  selectedTags: [],
  isMenuVisible: true,
  onFocus: _noop2["default"],
  maxLength: ""
};
Searchbox.label = _styledComponents["default"].label.withConfig({
  componentId: "sc-1fxn1mt-3"
})(["display:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
Searchbox.Holder = _styledComponents["default"].section.withConfig({
  componentId: "sc-1fxn1mt-4"
})(["position:relative;width:100%;"]);

var RightIcon = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-1fxn1mt-5"
})(["margin-left:0;"]);

var SpinnerHolder = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-6"
})(["margin:1.5rem 0 0.5rem 0;"]);

var HR = /*#__PURE__*/_styledComponents["default"].hr.withConfig({
  componentId: "sc-1fxn1mt-7"
})(["border-left:0;border-top:", ";margin:2px 20px 0 20px;"], "1px solid " + _color.grey.z200);

Searchbox.Cover = _styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-8"
})(["position:absolute;top:-6px;left:0;width:100%;background:#fff;height:8px;"]);
Searchbox.ListWrapper = _styledComponents["default"].section.withConfig({
  componentId: "sc-1fxn1mt-9"
})(["width:100%;position:absolute;background:#fff;box-shadow:", ";border-radius:", ";border-top:none;text-align:center;z-index:100;padding-bottom:", ";opacity:", ";transition:all ", " ease;", ""], function (props) {
  return props.isOpen ? "0px 2px 8px rgba(28, 28, 28, 0.15)" : "none";
}, "0 0 " + _misc["default"].radius + " " + _misc["default"].radius, function (props) {
  return props.isOpen ? "1rem" : "0";
}, function (props) {
  return props.isOpen ? "1" : "0";
}, _misc["default"].animationDuration, function (props) {
  return props.maxMenuHeight && (0, _styledComponents.css)(["max-height:", ";overflow-y:auto;"], props.maxMenuHeight);
});
Searchbox.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-10"
})(["position:relative;cursor:text;width:", ";min-height:", ";"], function (props) {
  return props.width ? props.width : "unset";
}, function (props) {
  return props.isNaked ? 0 : "6.5rem";
});
Searchbox.Header = _styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-11"
})(["position:relative;display:flex;align-items:center;justify-content:space-between;padding:", ";height:", ";font-size:", ";border:", ";border-radius:", ";box-shadow:", ";:focus-within{box-shadow:", ";}width:", ";"], function (props) {
  return props.noPadding ? "0 0.6rem" : "1rem 1rem";
}, function (props) {
  return props.noPadding ? "auto" : "4.8rem";
}, function (props) {
  return props.headerFont;
}, function (props) {
  return props.isNaked ? "none" : props.showMenu ? "0.1rem solid transparent" : props.isError ? "0.15rem solid #D64155" : "0.1rem solid " + _color.grey.z300;
}, function (props) {
  return props.showMenu ? _misc["default"].radius + " " + _misc["default"].radius + " 0 0" : props.showBtn ? "6px 0 0 6px" : _misc["default"].radius;
}, function (props) {
  return props.isNaked ? "none" : props.showMenu ? "0px 2px 8px rgba(28, 28, 28, 0.15)" : "none";
}, function (props) {
  return props.isNaked ? "none" : "0px 2px 8px rgba(28, 28, 28, 0.15)";
}, function (props) {
  return getWidth(props);
});
Searchbox.Left = _styledComponents["default"].div.withConfig({
  componentId: "sc-1fxn1mt-12"
})(["display:", ";align-items:center;width:100%;overflow:", ";white-space:", ";"], function (props) {
  return props.isTag ? "unset" : "flex";
}, function (props) {
  return props.isTag ? "inherit" : "hidden";
}, function (props) {
  return props.isTag ? "inherit" : "nowrap";
});
Searchbox.Input = _styledComponents["default"].input.withConfig({
  componentId: "sc-1fxn1mt-13"
})(["margin-left:0.5rem;width:", ";color:", ";overflow:hidden;text-overflow:ellipsis;outline:none;border:none;font-size:", ";&::placeholder{color:", ";font-weight:300;font-size:", ";}"], function (props) {
  return props.width ? props.width : "100%";
}, _color.black, function (props) {
  return props.headerFont;
}, _color.grey.z400, function (props) {
  return props.placeholderFont ? props.placeholderFont : "inherit";
});

var getWidth = function getWidth(props) {
  return props.width ? props.width : "100%";
};

var _default = Searchbox;
exports["default"] = _default;